export default "__VITE_ASSET__Bpn05$lw__"